import React from 'react'
import Seo from './Seo'
import Contact from './conatct'
import {Container, Row, Col} from 'reactstrap'
import Footer from './footer'
import PHImg from '../assets/images/Banner/Contact-Us.png'
import { useEffect } from 'react'

export default function ContactPage() {

  useEffect(() => {
    document.title = 'Contact Us | Agilus Technologies'
  }, [])
  return (
    <>
      <Seo
        title="Contact Us"
        description="Get in touch with Agilus Technologies to see how our IT infrastructure solutions can help your business."
        path="/contact"
      />
    {/* hero section */}
    <section className='custom-margin-for-header'>
        <img src={PHImg} className='img-fluid' />
      </section>

    <section className='text-center py-5'>
            <Container >
                <Row>
                <Col sm={12} className=''>
                    <h1>We would love to hear from you! </h1>
                    <p>Whether you have a question, need support, or want to explore how we can help you in simplifying your IT Management, we’re here to connect with you. Fill out the form below with your details, and our team will get back to you shortly.</p>
                    <p>Your journey to seamless IT management and innovative solutions starts here. Let’s make it happen together!</p>
                   
                </Col>
                </Row>
            </Container>

        </section>
    <div className='pb-5'></div>
    <Contact />
    <Footer />
    </>
  )
}
